import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom"
import { Button, createTheme, MantineProvider } from '@mantine/core';
import '@mantine/notifications/styles.css';

import { Notifications } from '@mantine/notifications';

import { AuthProvider } from '@hooks/useAuth'

import '@mantine/core/styles.css';

import './i18n';

const theme = createTheme({
  components: {
    Button: Button.extend({
      styles: {
        root: {
          height: '48px',
          borderRadius: '8px'
        }
      }
    }),
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <MantineProvider theme={theme}>
        <Notifications position="top-center" zIndex={1000} />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MantineProvider>
    </AuthProvider>
  </React.StrictMode>
);
